export default function setDataLayerConsentVariables(window, userCountryCode) {
    const GDPRCountries = ['AT', 'BE', 'BG', 'CH', 'CY', 'CZ', 'DE', 'DK', 'EE', 'EL', 'ES',
'FI', 'FR', 'GB', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'NL', 'PL', 'PT', 'RO', 'SE',
'SI', 'SK'];
      const GDPR = !userCountryCode ? true : GDPRCountries.includes(userCountryCode.toUpperCase());
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'locationDataLoaded',
        GDPR,
        userCountry: userCountryCode
      });
}